export const personalizationCallOut = ({ UIVersion }) => ({
  position: "relative",
  zIndex: UIVersion === 2 && 40,
});

export const callout =
  ({ backgroundColor, zIndex, position, UIVersion }) =>
  () => {
    return {
      display: "flex",
      flexDirection: "column",
      backgroundColor,
      border: "1px solid #000000",
      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.25)",
      borderRadius: UIVersion === 2 ? "10px" : "4px",
      backgroundPosition: "50% 50%",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      position: "absolute",
      zIndex,

      ...position,
    };
  };

export const text =
  ({ isEngineeredFor }) =>
  ({ isDesktop }) => {
    function getFontSize() {
      if (isEngineeredFor && isDesktop) {
        return "12px";
      }
      if (isEngineeredFor) {
        return "8px";
      }
      if (!isEngineeredFor && isDesktop) {
        return "20px";
      }
      return "10px";
    }

    return {
      color: "#fff",
      fontFamily: isEngineeredFor ? "diamanteefBoldItalic" : "garamondModBauer",
      fontWeight: "normal",
      fontSize: getFontSize(),
      lineHeight: !isDesktop ? "10px" : "20px",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
      textAlign: "center",

      position: "absolute",
      top: !isDesktop ? "24px" : "48px",
      left: !isDesktop ? "23px" : "49px",
      right: !isDesktop ? "23px" : "56px",
    };
  };

export const textV2 =
  ({ backgroundImageUrl, valueToDisplayLength }) =>
  ({ isDesktop }) => ({
    color: "black",
    fontFamily: "diamanteefBoldItalic",
    fontSize:
      backgroundImageUrl === ""
        ? valueToDisplayLength > 13
          ? "16px"
          : "24px"
        : valueToDisplayLength > 15
        ? "14px"
        : "18px",
    lineHeight: !isDesktop ? "10px" : "20px",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    textAlign: "center",

    position: "absolute",
    top: backgroundImageUrl === "" ? "50%" : "48px",
    left: "50%",
    transform:
      backgroundImageUrl === "" ? "translate(-50%, -50%)" : "translateX(-50%)",
  });

export const disclaimer = ({ isDesktop }) => ({
  fontFamily: "roboto",
  fontSize: !isDesktop ? "10px" : "12px",
  lineHeight: "1.4",
  letterSpacing: "0.1em",
  textAlign: "center",
  color: "grey7",
  position: "absolute",
  top: !isDesktop ? "1px" : "11px",
  left: "0",
  right: "0",
});

export const calloutImage = ({ backgroundImageUrl }) => ({
  backgroundImage: `url("${backgroundImageUrl}")`,
  backgroundPosition: "50% 50%",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  borderRadius: "0px 0px 1px 1px",
  flexGrow: "1",
  flexShrink: "1",
  position: "relative",
});

export const titleTextContainer = () => ({
  height: "30px",
  backgroundColor: "black",
  padding: "5px",
  fontSize: "14px",
  letterSpacing: "0.1em",
  textAlign: "center",
  textTransform: "uppercase",
  color: "white",
  borderRadius: "10px 10px 0px 0px",
});

export const bottomTextContainer = () => ({
  height: "36px",
  backgroundColor: "white",
  padding: "10px",
  fontFamily: "roboto",
  fontSize: "12px",
  lineHeight: "1.25",
  letterSpacing: "0.05em",
  textAlign: "center",
  color: "black",
  borderRadius: "0px 0px 10px 10px",
});
